import { Form, FormField } from "@/kit/ui/form";
import { useValibotForm, UseValibotFormReturn } from "@/utils/validation";
import { FormattedMessage, useIntl } from "react-intl";
import { InferOutput, object, string } from "valibot";
import { LazyEntitiesAutoCompleteSelection } from "./LazyEntitiesAutoComplete";
import { Button } from "@/kit/ui/button";
import { ComponentPropsWithoutRef } from "react";
import { cn } from "@/utils/tailwind";

const formSchema = object({
  entityId: string(),
});

export type AddMemberFormValues = InferOutput<typeof formSchema>;

export interface AddMemberFormProps extends Omit<
  ComponentPropsWithoutRef<typeof Form>,
  "form" | "onSubmit"
> {
  submitting?: boolean | undefined;
  onSubmit: (
    values: AddMemberFormValues,
    form: UseValibotFormReturn<typeof formSchema>,
  ) => void;
}

export function AddMemberForm({
  submitting,
  onSubmit,
  className,
}: AddMemberFormProps) {
  const intl = useIntl();
  const form = useValibotForm(formSchema);

  return (
    <Form
      form={form}
      onSubmit={(values: AddMemberFormValues) => onSubmit(values, form)}
      className={cn("flex gap-2 items-center", className)}
    >
      <FormField
        control={form.control}
        name="entityId"
        render={({ field }) => (
          <LazyEntitiesAutoCompleteSelection
            {...field}
            placeholder={intl.formatMessage({ defaultMessage: "Enter a name" })}
          />
        )}
      />

      <Button variant="primary" disabled={submitting} type="submit">
        <FormattedMessage defaultMessage="Add Member" />
      </Button>
    </Form>
  );
}
